import { render } from "./MultiSelectAutoComplete.vue?vue&type=template&id=61f70254&scoped=true"
import script from "./MultiSelectAutoComplete.vue?vue&type=script&lang=js"
export * from "./MultiSelectAutoComplete.vue?vue&type=script&lang=js"

import "./MultiSelectAutoComplete.vue?vue&type=style&index=0&id=61f70254&lang=scss&scoped=true"

import exportComponent from "/Users/klaus/Projects/sfdc-happy-soup/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f70254"]])

export default __exports__